import DebtorsList from "./components/DebtorsList";
export default DebtorsList;
